import './App.css';
import './DappForm.css';
import './DesignComponents.css';
import './summaryDetails.css';
import './home.css';
import {useState, useEffect, useRef} from 'react';
import * as ServerComms from './utilities/ServerComms';
import * as OverallTypeChecks from './OverallTypeChecks';
import * as CoreFns from './utilities/CoreFns';

import Dimensions from './Dimensions';
import {parseElement, fillUpEntityRecursively} from './utilities/FillUp';
import OperationalTransformTree from './OperationalTransformTree';
import UpdateMain from './UpdateMain';
import PopUp from './PopUps/PopUp';
import NormalBtn from './StockItems/NormalBtn';
import IntroPage from './intro/IntroPage';
import RunOrSimulate from './RunOrSimulate';
import MainControl from './MainControl';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as ActionModifiers from './ActionModifiers';

import './t8.css';

//enable things like transfer ether on f.e. - no! no demad.

//do loans (figure this out - not urgent)//learn the mxood contract.//leonbuh/drip network/dariusgriffi213

//reverse translate into contract - patent!

//105 may not be image if its audio or video. 
//check operational transform trees if its before / after is a whack. unlikely to intersact cos quite different.

//do opensea depends on network. limit opensea to eth/poly.

//brave enough to walk alone in the dark.
//hack your motivation - care enough to persist
//you have to be extraordinary to win.

//prevent click when isburning/isminting.
//do token lock. 

//show products built on cues, eg the exchange one and the jeremiah one. 

//okrs : number of bugs, number of clicks, breadth of use cases.

//add time string

//kiv - make use of output variables for subsequent action. 
//**when calling functions, ensuring that existing contract values are the latest. -> apply checked consistently through all database assets. :: check simulator functions all over again. we can do this perhaps 

//do walk down for list (at least those with nos specified?)
//allow tuple ouptuts to be directly used as objects. 
//ai to determine templates. so can customize.

//how to show nft pictures lol.
//show most viewed functions on front page.

//update exchange contract to uniswap.
//multiinstance not working.
//how come sometimes old progs don't load.

//enable a design like https://multichainstaker.io
//lists / tables.
//dynamic text can be link or button

//para that describes what the default smart contract produced does/not do.
//**error handling for new -> check.
//firefox offset.

// improve usability ( add templates), and get users (be our own users by doing up some fiverr projects and publicize them on front page, twitter posts)

// crop

// how come page doesn't follow.

//add instructions above code line, if those exist. in general need to explain code. 

//firefox template shrink button strange.

//screen and inputs should show respective grids.
//kiv -> inputspecialtype and specifyobjectdirectly.
//explain base uri.
//azer420. escrow - tman12345

function App() {

  const [error, setError] = useState(false);
  const [sessionID, setSessionIDA] = useState(0);
  const [userID, setUserID] = useState(0);
  const [randomCode, setRandomCode] = useState('');
  const [palette, setPalette] = useState([]);

  function setSessionID(k){ setSessionIDA(k); document.sessionID = k;}
  const [signKey, setSignKeyA] = useState('');
  function setSignKey(k){ setSignKeyA(k); document.signKey = k;}

  const [isConnected, setIsConnected] = useState(false);
  const [currentList, setCurrentListA] = useState(false);
  function setCurrentList(l){
    setCurrentListA(l);
    document.currentList = l;
  }
  function setServerNos(k){ document.serverNos = k;}

  // console.log(window. location.href);

  const [userNos, setUserNosA] = useState({n:-1});
  function setUserNos(k){ setUserNosA(k); document.userNos = k;}

  const [updatesToPropagate, setUpdatesToPropagate] = useState([]);

  const [otherPeoplesPositions, setOtherPeoplesPositionsA] = useState([]);
  const [programSetID, setProgramSetIDA] = useState(0);
  function setProgramSetID(k){ setProgramSetIDA(k); document.programSetID = k;}

  const [fakePath, setFakePath] = useState([]);
  const [updateFns, setUpdateFns] = useState({});
  const [history, setHistory] = useState(false);
  const [logInState, setLogInState] = useState(false);

  const [isDisplayPage, setIsDisplayPage] = useState(false);
  const [nosCredits, setNosCredits] = useState(0);
  const [sortBy, setSortBy] = useState('Title');

  const [tabSelected, setTabSelected] = useState({t:'Pages', i:3});
  const [isShowingSomeDropDown, setIsShowingSomeDropDown] = useState(false);

  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  const [isClickingOnContentDiv, setIsClickingOnContentDiv] = useState(false);
  const [refObject, setRefObject] = useState({});

  const [itemEdited, setItemEditedX] = useState(false);
  const [whichFEOrPU, setWhichFEOrPU] = useState(false);
  const [hidePanelRelativeItems, setHidePanelRelativeItems] = useState({});
  const [accessLevel, setAccessLevel] = useState(-1);
  const [navBarHeight, setNavBarHeight] = useState(0);
  const [zoom, setZoom] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const [translateY, setTranslateY] = useState(0);
  const [screenSize, setScreenSize] = useState(0);
  const [detailsWidth, setDetailsWidth] = useState(270);
  const [isGone, setIsGone] = useState(false);
  const [tempAddr, setTempAddr] = useState('');
  const [heightsOfPages, setHeightsOfPages] = useState({});
  const [chains, setChains] = useState([]);
  const [itemCategories, setItemCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [colorCombo, setColorCombo] = useState(0);
  var cust = ActionModifiers.createNull();  
  const [customColorRecord, setCustomColorRecord] = useState(cust);
  const [isShowingCustom, setIsShowingCustom] = useState(false);



  const { height, width } = Dimensions();

  var tabWidth = 60;
  var contentsHeight = height - navBarHeight;
  var widthAvailable = width - tabWidth - detailsWidth;

  function getChains(){
      var postFunction = function(responseIn){
        var chainsIn = responseIn.v.map((aR1, index)=>{
          var aR = aR1.v;
          return {n:aR[0].v, n1:aR[1].v, i:aR[2].v, c:aR[3].v, ci:aR[4].v, d:aR[5].v, a:'https://www.cues.sg/uploaded_pictures/'+aR[6].v, u:aR[7].v, l:aR[8].v, b:[aR[9].v], r:[aR[10].v], tok:aR[11].v, coinAdd:aR[12].v, nftAdd:aR[13].v, sN:aR[14].v, multiAdd:aR[15].v, multiBlock:aR[16].v, network:aR[17].v};

          // return {n:aR[0].v, n1:aR[1].v, i:aR[2].v, c:aR[3].v, ci:aR[4].v, d:aR[5].v, a:'https://www.cues.sg/uploaded_pictures/'+aR[6].v, u:aR[7].v, l:aR[8].v, b:[aR[9].v], r:[aR[10].v], tok:aR[11].v};
        });
        setChains(chainsIn);
      }
      var failFunction = function(){
        console.log('Fail');
      }
      var passObject = {
          u:'getChains',
        };
        
     ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

  }

  function getItemCategories(){
      var postFunction = function(responseIn){
        setItemCategories(responseIn.v);
      }
      var failFunction = function(){
        console.log('Fail');
      }
      var passObject = {
          u:'getItemCategories',
        };
     ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
  }

  function centerZoomAct(zoomHere, sZ){

    var minX = +Infinity;
    var minY = +Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    var ssSizes = StyleFunctions.screenWidthsAndHeights(sZ);
    var insetWidth = ssSizes.insetWidth;
    var insetHeight = ssSizes.insetHeight;

    var t = ['fe', 'pu'];
    t.forEach((aT, index)=>{
      var feKeys = Object.keys(currentList[aT]);
      for (var i = 0; i < feKeys.length; i++){
        var thisKey = feKeys[i];
        var thisPos = currentList[aT][thisKey].pos;
        if (thisPos.xP < minX){
          minX = thisPos.xP;
        }
        if (thisPos.xP > maxX){
          maxX = thisPos.xP;
        }
        var yPos = thisPos.yP * insetHeight;
        if (yPos < minY){
          minY = thisPos.yP;
        }

        var yEnd = yPos;
        if (aT === 'fe'){
          if (heightsOfPages[thisKey]){
            yEnd = yPos + heightsOfPages[thisKey];
          }
        }else{
          yEnd = yPos + insetHeight;
        }

        if (yEnd > maxY){
          maxY = yEnd;
        }
      }
    })

    var origScale = Math.pow(10, zoomHere * 0.1);

    var widthNeeded = (1 + maxX - minX) * insetWidth;
    var heightNeeded = (maxY - minY);

    var toAddX = 0.05 * widthAvailable / origScale;
    var toAddY = 0.05 * contentsHeight / origScale;

    var midX = 0.45 * widthAvailable / origScale;
    var midXOrig = widthNeeded/2;

    var ppX = midXOrig - midX;

    var translateX1 = (minX - 0.5) * insetWidth - toAddX + (ppX)
    var translateY1 = (minY) - toAddY;

    // var translateX1 = (minX * 1.1 * insetWidth - 0.5 * insetWidth - 0.2 * insetWidth);
    // var translateY1 = (minY * 1.1 * insetHeight - 0.1 * insetHeight);
    // var translateY1 = (minY * 1.1 * insetHeight - 0.1 * insetHeight);

    setTranslateX(-translateX1);
    setTranslateY(-translateY1);
    if (scrollableElement && scrollableElement.current){
      scrollableElement.current.scrollTo({ behavior: 'smooth', top:0, left:0 });
    }
  }

  function setScreenSizeX(x){
    setScreenSize(x);
    resetZoom(x);
  }

  function resetZoom(sZ){

    var minX = +Infinity;
    var minY = +Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    var ssSizes = StyleFunctions.screenWidthsAndHeights(sZ);
    var insetWidth = ssSizes.insetWidth;
    var insetHeight = ssSizes.insetHeight;

    var t = ['fe', 'pu'];
    t.forEach((aT, index)=>{
      var feKeys = Object.keys(currentList[aT]);
      for (var i = 0; i < feKeys.length; i++){
        var thisKey = feKeys[i];
        var thisPos = currentList[aT][thisKey].pos;
        if (thisPos.xP < minX){
          minX = thisPos.xP;
        }
        if (thisPos.xP > maxX){
          maxX = thisPos.xP;
        }

        var yPos = thisPos.yP * insetHeight;
        if (yPos < minY){
          minY = thisPos.yP;
        }

        var yEnd = yPos;
        if (aT === 'fe'){
          if (heightsOfPages[thisKey]){
            yEnd = yPos + heightsOfPages[thisKey];
          }
        }else{
          yEnd = yPos + insetHeight;
        }

        if (yEnd > maxY){
          maxY = yEnd;
        }
      }
    })

    var widthNeeded = (1 + maxX - minX) * insetWidth;
    var heightNeeded = (maxY - minY);

    var heightRatio = 0.9 * contentsHeight / heightNeeded;
    var widthRatio = 0.9 * widthAvailable / widthNeeded;

    var scale = widthRatio;
    if (heightRatio < widthRatio){
      scale = heightRatio;
    }

    var zoomHere = 10 * Math.log(scale) / Math.log(10);
    setZoomX(zoomHere, sZ);
  }

  function centerZoom(){
    centerZoomAct(zoom, screenSize);
  }

  function setZoomX(zoom, sZ){
    setZoom(zoom);
    centerZoomAct(zoom, sZ);
  }



  function setItemEdited(x){
    if (document.itemEdited && document.itemEdited.t === 'asset'){
      var p2 = document.getElementById(document.itemEdited.path[1]);
      if (p2){
        p2.style.border = '';
      }
    }
    if (x && x.t === 'asset'){
      var p3 = document.getElementById(x.v);
      if (p3){
        p3.style.border = '2px solid blue';
      }else{
        setItemEditedX(false);
      }
    }
    setItemEditedX(x);
    document.itemEdited = x;
  }

  const [saveState, setSaveState] = useState(0);
  const [doingWhat, setDoingWhat] = useState(false);
  const [ownVariablesForDeployment, setOwnVariablesForDeployment] = useState({});
  const scrollableElement = useRef(null);

  function changeTab(element, subpage){
      setTabSelected({t:element, s:subpage});
      setIsShowingSomeDropDown(false);
  }


  function setIsSendingSomething(state){
    document.isSendingSomething = state;
  }

  var extraScreenSet = [];
  var systemProgramSetID = 0;
  var currentPageSet = [];
  var isShowingPrevious = 0;
  var state = window.history.state;
  if (state){
    if (state.extraPath){
      extraScreenSet = state.extraPath;
    }  
    if (state.currentPageSet){
      currentPageSet = state.currentPageSet;
    }
    if (state.programSetID){
      systemProgramSetID = state.programSetID;
    }
    if (state.isShowingPrevious){
      isShowingPrevious = state.isShowingPrevious;
    }
  }
  
  function clickBack(){
    window.history.back();
  };

  function setSelectedStep(newPage, fresh, newProgramSetID, sets){

    var newCurrentPageSet;
    var programSetIDIn;
    if (fresh){
      programSetIDIn = newProgramSetID;
      newCurrentPageSet = sets;
    }else{
      programSetIDIn = programSetID;
      newCurrentPageSet = [...currentPageSet, newPage];
    }
    window.history.pushState({extraPath:[], currentPageSet:newCurrentPageSet, programSetID:programSetIDIn, isShowingPrevious}, '', '/dapps/');
    setFakePath(window.history.state.extraPath);
  }


  function setOtherPeoplesPositions(x){
    setOtherPeoplesPositionsA([...x]);
  }

  function onBackButtonEvent(e){
    setFakePath(window.history.state.extraPath);
    if (window.history.state.extraPath.length === 0 && window.history.state.currentPageSet.length === 0){
      revertProgramIDFn();
    }
  }

  function getLaunchedPage(urlSet){
      var postFunction = function(responseIn){
        if (responseIn.v[0].v === 'success'){
          var msg = fillUpEntityRecursively(responseIn.v[1]);
          setCurrentList(msg);
          setIsDisplayPage({t:4, programSetID:responseIn.v[2].v})
        }else if (responseIn.v[0].v === 'pageDoesNotExist'){
          setIsDisplayPage({t:2});
        }else if (responseIn.v[0].v === 'timeOut'){
          setIsDisplayPage({t:3});
        }
      }
      var failFunction = function(){
        console.log('fail');
      }
      var url = urlSet.split("/")[0];
      var passObject = {
          u:'getLaunchedPage',
          url
        };
        
     ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
      
  }

  const ws = useRef(null);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var c = urlParams.get('c');
  var n = urlParams.get('n');

  function tryConnect(passObject){
    wsConnect();
    reallyConnect(passObject);

  }
  function reallyConnect(passObject){

    if (document.tryLaIsConnected && ws && ws.current){
      ws.current.chat(passObject);
    }else{
      setTimeout(function(){ reallyConnect(passObject); }, 500);
    }
  }              

  function doC(){

      function postGetKeys(response){

        if (response.t === 'list'){
          var userID = +response.v[0].v;
          var sessionID = +response.v[1].v;
          var signKey = response.v[2].v;

          var logInStateV = urlParams.get('lV');
          var logInStateT = urlParams.get('lT');

          var logInStateIn = false;
          if (logInStateT){
            logInStateIn = {t:logInStateT, v:logInStateV}
          }
          setSessionID(sessionID);
          reallySignIn(signKey, userID, logInStateIn, false);

          var newCurrentPageSet = [];
          var path = urlParams.get('path');
          if (path){
            var set = path.split('-');
            newCurrentPageSet = set.map((aSet, index)=>{
              return aSet.split(',');
            })
          }

          var isShowingPreviousIn = 0;

          var requirements = +urlParams.get('req');

          var programSetID = +urlParams.get('programSetID');
          window.history.replaceState({extraPath:[], currentPageSet:newCurrentPageSet, programSetID, isShowingPrevious:0}, null, '?');
          window.history.pushState({extraPath:[{t:'credits',v:requirements}], currentPageSet:newCurrentPageSet, programSetID, isShowingPrevious:isShowingPreviousIn}, null, '?');
          setHidePanelRelativeItems({});

          if (programSetID > 0){

            var passObject = {
                fn:'oldProgram',
                sessionID,
                signKey,
                userID,
                programSetID,
              };

            tryConnect(passObject);
          }
        }else{
          window.history.replaceState({extraPath:[], currentPageSet:[], programSetID:0, isShowingPrevious:0}, null, '?');
        }
      }

      var cS = urlParams.get('cS');
      ServerComms.fetchSomething({u:'readCS', cS}, postGetKeys);
  }


  function doN(){

    function postGetKeys(response){
      if (response.t === 'list'){

        var userID = +response.v[0].v;
        var sessionID = +response.v[1].v;
        var signKey = response.v[2].v;
        var logInStateV = urlParams.get('lV');
        var logInStateT = urlParams.get('lT');

        var logInStateIn = false;
        if (logInStateT){
          logInStateIn = {t:logInStateT, v:logInStateV}
        }
        setSessionID(sessionID);
        reallySignIn(signKey, userID, logInStateIn, false);
        window.history.replaceState({extraPath:[], currentPageSet:[], programSetID:0, isShowingPrevious:0}, null, '?');

      }
    }
    var rS = urlParams.get('rS');
    var id = urlParams.get('id');
    ServerComms.fetchSomething({u:'unwindOnceOffID', rS, id}, postGetKeys);

  }

  useEffect(() => {
    document.liveBit = [];
    document.buffer = [];
    getChains();

    var storage = localStorage.getItem('eEverything');
    if (c){
      doC();
    }else if (n){
      doN();
    }else{
      var backAmt = extraScreenSet.length + currentPageSet.length + (isShowingPrevious ? 1 : 0);
      for (var i = 0; i < backAmt; i++){
        clickBack();
      }
      setTimeout(function(){ 
        window.history.replaceState({extraPath:[], currentPageSet:[], programSetID:0, isShowingPrevious:0}, null, null);
        setFakePath(window.history.state.extraPath);
      }, 10);

      if (storage){
        var comb = JSON.parse(storage);
        document.sessionID = comb.sessionID;
        setSessionID(comb.sessionID);
        reallySignIn(comb.sK, comb.userID, comb.logInState, false);
      }else{
        document.userID = 0;
        initiateSessionIDWithRandomCode();        
      }
    }


    const pathname1 = window.location.pathname;
    var pathname = pathname1.substr(7);

    if (pathname){
      setIsDisplayPage({t:1});
      getLaunchedPage(pathname);
      return;
    }

    window.addEventListener('popstate', onBackButtonEvent);
    refreshImages();
    getItemCategories();

    // document.userID = 0;
    document.body.style.backgroundColor = '#FFFBF0';
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);  
    };
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  function refreshImages(){
    function postGetPalette(response){
      if (response.t === 'list'){
        setPalette(response.v);
      }
    }
    ServerComms.fetchSomething({u:'getPalette'}, postGetPalette);
  }

  function initiateSessionIDWithRandomCode(){
    var postFunction = function(responseIn){
      var sessionIDIn = responseIn.v[0].v;
      var randKey = responseIn.v[1].v;
      setSessionID(sessionIDIn);
      setRandomCode(randKey);
      setLogInState(false);
      setUserID(0);
      document.userID = 0;
      setSignKey('');
      setHistory(false);
      setNosCredits(0);
      localStorage.setItem('eEverything', '');

    }
    var failFunction = function(){
      console.log("Fail");
    }
    var passObject = {
        u:'initiateSessionIDWithRandomCodeFrontPage',
      };
      
   ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

  }

  function wsConnect(){
    try{
      document.forceDisconnect = false;
        ws.current = new WebSocket("wss://www.cues.sg/websockets_example_endpoint.yaws?extversion=false&keepalive=true&timeout=false");
        if (!ws.current){
          console.log("cannot connect");
          return;
        }
        ws.current.onopen = function(){
          console.log('Reconnected');
          document.tryLaIsConnected = true;
          setIsConnected(true);
          reconnectToProgram();
        };
        ws.current.chat = function(passObject){
          var message = JSON.stringify(passObject);
          ws.current.send(message);            
        }
        ws.current.onclose = function(){
          document.tryLaIsConnected = false;
          setIsConnected(false);
          if (!document.forceDisconnect){
            console.log("WS Attempt Re-connect");
            setTimeout(function(){ wsConnect(); }, 0);
          }
        } 
        ws.current.onmessage = function(m){
          if (m.data){
            var text = m.data;
            postProcess(text);
          }
        }        
      }catch(err){
        console.log(err);
      }
  }


  function processMessageProper(xSet, isNew, programSetIDIn){

    var serverNos = xSet[0].v;
    setServerNos(serverNos);
    var msg = fillUpEntityRecursively(xSet[1]);
    conditionalChanges(msg);

    document.liveBit = [];
    document.buffer = [];
    setUserNos(xSet[2].v);
    setIsSendingSomething(false);

    setCanRedo(false);
    setCanUndo(false);

    setSaveState(0);
    
    if (isNew){
      changeTab('ElementStyle', 0);
      setSelectedStep(['edit'], 1, programSetIDIn, [['edit']]);
    }

  }

  function simplDuplicate(e){
    setDoingWhat({t:'duplicate', programSetID});
    ServerComms.fetchSomething({u:'duplicateProgram', programSetID, sessionID, signKey, userID}, revertProgramIDFn);

  }

  function organicChanges(changes){
    if (accessLevel < 2){
      if (accessLevel === -1){
        setTimeout(function(){ organicChanges(changes); }, 500);
        return;
      }else{
        var p = window.confirm('Sorry, you do not have edit rights to this dApp. Click yes if you would like to make a duplicate of this specification so that you can make modifications');
        if (p){
          simplDuplicate();
        }
        return;
      }
    }
    var changes2 = JSON.parse(JSON.stringify(changes));
    var changes3 = JSON.parse(JSON.stringify(changes));
    var changes4 = JSON.parse(JSON.stringify(changes));

    queueToSendAct(changes2);
    UpdateMain(changes3, currentList, width, height);
    setUpdatesToPropagate(changes4.filter((aP, index)=>{return aP.q !== 1}));
    conditionalChanges(currentList);
  }

  function queueToSendAct(changes){
    if (!document.isSendingSomething){
      sendUpdate(changes, document.serverNos)
    }else{
      addToBuffer(changes);
    }
  }
  const addToBuffer = (newBuffer) => {
    document.buffer = [...document.buffer, ...newBuffer];
  };


  function postPostFunction(comp){
    var header = comp.v[0].v;
    if (header === 're'){
      var serverNos2 = comp.v[1].v;  
      if (serverNos2 > document.serverNos){
        setServerNos(serverNos2);
        var newBuffer1 = document.buffer;
        var listOfUserUpdates = comp.v[2].v;
        listOfUserUpdates.forEach((aUserUpdateSet, index)=>{
          var aUserUpdate = aUserUpdateSet.v;
          newBuffer1 = updateBufferEtc(newBuffer1, aUserUpdate); 
        })

        document.buffer = newBuffer1;

        if (document.buffer.length === 0){
          document.liveBit = [];
          setIsSendingSomething(false);
        }else{
          sendUpdate(document.buffer, serverNos2);
          document.buffer = [];
        }
        setCanUndo(comp.v[4].v);
        setCanRedo(comp.v[5].v);

      }else{
        console.warn(comp);
      }
      setSaveState(2);
      setTimeout(function(){ setSaveState(0); }, 500);
    }else if (header === 'samula'){
      setIsGone(true);
      document.liveBit = [];
      document.buffer = [];
      setIsSendingSomething(false);
    }else if (header === 'u'){
      setSaveState(0);
      var status = comp.v[1];
      if (status.t === 'atom'){
        if (status.v === 'u'){
          setCanUndo(false);
          window.alert("Nothing to Undo");
          return;
        }else if (status.v === 'r'){
          // setUndoCount(0);
          setCanRedo(false);
          window.alert("Nothing to Redo");
          return;
        }
      }
    }else if (header === "'$gen_cast'"){
      doGetUpdate();
    }else{
      console.warn(comp);
    }
  }

  function getHistoryWithDefaults(){
    getHistory(sessionID, signKey, userID);
  }

  function getHistory(sessionIDIn, signKey, userIDIn){

    var postFunction = function(responseIn){
      setNosCredits(responseIn.v[1].v);
      setHistory(responseIn.v[0].v);
    }
    var failFunction = function(){
      console.log("Fail");
    }
    var passObject = {
        u:"getHistory",
        sessionID:sessionIDIn,
        signKey,
        userID:userIDIn,
      };
        
    ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

  }
  function updateBufferEtc(buffer, aUserUpdate){

    var updatesList = aUserUpdate.map((anUpdate, index)=>{
      var updateType = anUpdate.v[0].v;
      var p = anUpdate.v[1].v;
      var w = simplDepth(anUpdate.v[2].v);

      if (updateType === 'a'){
        var n = anUpdate.v[3].v.map((anElement, index)=>{
            return parseElement(anElement);
          })
        return {t:updateType, p, n, w};
      }else if (updateType === 'd'){
        var l = anUpdate.v[3].v;
        return {t:updateType, p,l, w};
      }else if (updateType === 'w'){
        var out = fillUpEntityRecursively(anUpdate.v[1]);
        return {t:updateType,w,n:out};
      }else if (updateType === 'r'){
        return {t:updateType,w,i:anUpdate.v[1].v};
      }else{
        console.warn(anUpdate);
        return false;
      }

    })

    var newLiveBit = OperationalTransformTree(updatesList, document.liveBit, 0);
    updatesList = OperationalTransformTree(document.liveBit, updatesList, 1);
    // setLiveBit(newLiveBit);
    document.liveBit = newLiveBit;

    var newBuffer = OperationalTransformTree(updatesList, document.buffer, 0);

    updatesList = OperationalTransformTree(document.buffer, updatesList, 1);
    
    var updatesList2 = JSON.parse(JSON.stringify(updatesList));

    UpdateMain(updatesList, document.currentList, width, height);
    setUpdatesToPropagate(updatesList2);
    conditionalChanges(document.currentList);
    return newBuffer;

  }

  function failSendFunction(attemptNos){
    return function(){
      setSaveState(3);
      var delay = 2^(attemptNos) * 1000;
      setTimeout(function(){ 
        sendUpdateReal(document.liveBit, document.serverNos, attemptNos + 1);
      }, delay);

    }
    
  }

  function clickUndoRedo(fn){
    return function(e){
      ServerComms.fetchSomething({u:fn, userNos:document.userNos, programSetID:document.programSetID, sessionID:document.sessionID, signKey:document.signKey, userID:document.userID, serverNos:document.serverNos}, postPostFunction);
    }
  }

  function doGetUpdate(e){
    ServerComms.fetchSomething({u:'getUpdate', userNos:document.userNos, programSetID:document.programSetID, sessionID:document.sessionID, signKey:document.signKey, userID:document.userID, serverNos:document.serverNos}, postPostFunction);
  }

  function sendUpdate(changes, serverNos){
    document.liveBit = changes;
    setIsSendingSomething(true);
    setSaveState(1);
    sendUpdateReal(changes, serverNos, 0);
  }

  function sendUpdateReal(changes, serverNos, attemptNos){
    ServerComms.fetchSomething({u:'update', changes, serverNos:document.serverNos, userNos:document.userNos, programSetID:document.programSetID, sessionID:document.sessionID, signKey:document.signKey, userID:document.userID}, postPostFunction, failSendFunction(attemptNos));
  }

  function simplDepth(list){
    return list.map((aList, index)=>{return aList.v});
  }


  function conditionalChanges(currentList){
    var p = OverallTypeChecks.checkErrors(currentList, organicChanges, sessionID, signKey, userID, chains, changeTab);
    document.errorPiece = p;
    setError(p);
    setCurrentList(currentList);
  }

  function reconnectToProgram(){
    if (document.programSetID > 0){      
        var passObject = {
            fn:'oldProgramReconnect',
            sessionID:document.sessionID,
            signKey:document.signKey,
            userID:document.userID,
            programSetID:document.programSetID,
            userNos:document.userNos,
          };
          reallyConnect(passObject);
    }
  }

  function postProcess(text){
    if (!text){
      return;
    }
    var comp = ServerComms.erlangDecode(text);
    if (comp.t === 'tuple'){
      var header = comp.v[0].v;
      if (header === 'infoSet'){
        setIsLoading(false);
        setProgramSetID(comp.v[1].v);
        setIsGone(false);
        setAccessLevel(comp.v[5].v);
        processMessageProper(comp.v[2].v, 1, comp.v[1].v);
        setUserID(comp.v[3].v);
        document.userID = comp.v[3].v;
        var isNew = comp.v[4].v;
        if (isNew){
          setDoingWhat({t:'guide',v:0});
        }else{
          setDoingWhat(false);
        }
      }else if (header === 'o'){
        doGetUpdate();
      }else if (header === 'reconnect'){
        setUserNos(comp.v[1].v);
      }else if (header === 'l'){ //other peoples locs.
        var nos = comp.v[2].v; var w = simplDepth(comp.v[1].v); var a = simplDepth(comp.v[4].v); var name = comp.v[3].v;
        var l = {nos, w, a, name};
        var haveFound = false;
        for (var i4 = 0; i4 < otherPeoplesPositions.length; i4++){
          if (otherPeoplesPositions[i4].nos === nos){
            otherPeoplesPositions[i4] = l;
            haveFound = true;
            break;
          }
        }
        if (!haveFound){
          otherPeoplesPositions.push(l);
        }
        setOtherPeoplesPositions(otherPeoplesPositions);
        
      }else if (header === 'k'){
        var nosToKill = comp.v[1].v;
        for (var i40 = 0; i40 < otherPeoplesPositions.length; i40++){
          if (otherPeoplesPositions[i40].nos === nosToKill){
            otherPeoplesPositions.splice(+i40, 1);
            break;
          }
        }
        setOtherPeoplesPositions(otherPeoplesPositions);
      }
    }else if (comp.t === 'atom'){
      if (comp.v === 'noAccessToIntent'){
        window.alert("Sorry, you do not have access to this intent");
        revertProgramIDFn();
      }else{
        console.log(comp);
      }
    }else if (comp.t === 'number'){
    }else{
      console.log(comp);
    }
  }


  function reallySignIn(aMessage, userIDIn, logInMtd, goBack){
    if (goBack){
      if (extraScreenSet.length > 0){
        clickBack();
      }
    }
    setHistory('loading');
    getHistory(document.sessionID, aMessage, userIDIn);
    setUserID(userIDIn);
    document.userID = userIDIn;
    setLogInState(logInMtd);
    setSignKey(aMessage);

    var comb = {sK:aMessage,logInState:logInMtd,userID:userIDIn,sessionID:document.sessionID};
    localStorage.setItem('eEverything', JSON.stringify(comb));

  }

  function responseGoogleYes(response){
    var tokenId = response.tokenId;
    var email = response.profileObj.email;

    var postFunction = function(responseIn){
      reallySignIn(tokenId, responseIn.v, {t:'email', v:email}, true);
    }

    var failFunction = function(){
      console.log("Fail");
    }

    var passObject = {
      u:'signInGoogle',
      email,
      tokenId,
      userID,
      sessionID:document.sessionID,
    };
      
   ServerComms.fetchSomething(passObject, postFunction, failFunction, []);             

  }

  const addToExtraScreen = (extraScreen) => {

    if (extraScreen.fn1){
      updateFns["a1_"+extraScreenSet.length] = extraScreen.fn1;
      delete extraScreen.fn1;
    }else{
      delete updateFns["a1_"+extraScreenSet.length];
    }
    setUpdateFns(updateFns);
    actualAddToScreen(extraScreen);
  };

  const actualAddToScreen = (extraScreen) =>{
    setUpdatesToPropagate([]);
    var extraPath = [...extraScreenSet, extraScreen];
    window.history.pushState({extraPath, currentPageSet, programSetID}, '', '');
    setFakePath(window.history.state.extraPath);
  }


  function logOut(){
    revertProgramIDFnX();
    initiateSessionIDWithRandomCode();
  }

  function revertProgramIDFnX(){
      var backAmt = extraScreenSet.length + currentPageSet.length ;
      for (var i = 0; i < backAmt; i++){
        clickBack();
      }
  }

  function justLoadHistory(){
    getHistory(document.sessionID, document.signKey, document.userID);
  }

  function revertProgramIDFn(){
      document.forceDisconnect = true;
      if (ws && ws.current){
        ws.current.close();
      }
      setItemEdited(false);
      setCurrentList(false);
      setUserNos({n:-1})                
      justLoadHistory();
  }

  if (isDisplayPage){
    if (chains.length === 0){
      return <div>Loading...</div>
    }
    if (isDisplayPage.t === 1){
      return <div style={{paddingTop:'50px'}}><center><b>Loading...</b></center></div>
//
    }else if (isDisplayPage.t === 2 || isDisplayPage.t === 3){

      function clickRefresh(){
        document.location.href = 'https://www.cues.sg/dapps/';
      }
      var pageText;
      if (isDisplayPage.t === 2){
        pageText = 'Sorry this page does not exist';
      }else if (isDisplayPage.t === 3){
        pageText = 'Sorry this dapp has expired. Please ask the owner of the dapp to add time to the dapp.';
      }
      return <div style={{paddingTop:'50px'}}><center>
            <b>{pageText}</b><br/><br/>
            <NormalBtn onClick={clickRefresh} title='Back to Main' />
          </center></div>
//      
    }else if (isDisplayPage.t === 4){
      if (currentList){
        var urlHeader = CoreFns.urlHeaderStart();
        return <RunOrSimulate chains={chains} overallWidth={width} currentList={currentList} width={width} height={height} overlays={null} programSetID={isDisplayPage.programSetID} ownVariables={ownVariablesForDeployment} setOwnVariables={setOwnVariablesForDeployment} urlParamsForExecution={queryString} run={true} isReal={true} offsetTop={0} offsetLeft={0} urlHeader={urlHeader}/>
      }else{
        return <div>Loading...</div>
      }
    }
  }
//  

  function reallySelectNew(templateID, code){
    var sc = code.sc;
    var scKeys = Object.keys(sc);
    scKeys.forEach((aScKey, index)=>{
      sc[aScKey].template = 1;
      var addSet = sc[aScKey].addSet;
      var addSetKeys = Object.keys(addSet);
      delete addSet[addSetKeys[0]].code;
    })

    var passObject1 = {
        fn:'newDapp',
        sessionID,
        signKey,
        userID,
        code,
      };
    setDoingWhat({t:'newDapp', v:templateID});
    tryConnect(passObject1);
  }

  function selectNew(templateID, code){

    setIsLoading(true);
    revertProgramIDFnX();
    setTimeout(function(){ reallySelectNew(templateID, code); }, 100);
  }

  // console.log(currentList);


  var style = {
    position: "fixed",
    overflowY: "hidden",
    overflowX: "hidden",
    top: 1, 
    bottom: 1,
    left: 1,
    right: 1,
  }

  var popUps = extraScreenSet.map((aScreen, index)=>{
    return (<PopUp chains={chains} aScreen={aScreen} setWhichFEOrPU={setWhichFEOrPU} width={width} height={height} clickBack={clickBack} key={index} currentList={currentList} organicChanges={organicChanges} setNosCredits={setNosCredits} userNos={userNos} sessionID={sessionID} signKey={signKey} addToExtraScreen={addToExtraScreen} updateFns={updateFns} whichPopup={index} userID={userID} reallySignIn={reallySignIn} randomCode={randomCode} programSetID={programSetID} responseGoogleYes={responseGoogleYes} logInState={logInState} nosCredits={nosCredits} selectNew={selectNew} setItemEdited={setItemEdited} doingWhat={doingWhat} setDoingWhat={setDoingWhat} setIsClickingOnContentDiv={setIsClickingOnContentDiv} refObject={refObject} setIsShowingSomeDropDown={setIsShowingSomeDropDown} hidePanelRelativeItems={hidePanelRelativeItems} setHidePanelRelativeItems={setHidePanelRelativeItems} setAccessLevel={setAccessLevel} setTempAddr={setTempAddr} centerZoom={centerZoom} changeTab={changeTab} palette={palette} itemCategories={itemCategories} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom}  />);
  });

  var currentPage = '';
  if (currentPageSet.length > 0){
    currentPage = currentPageSet[currentPageSet.length - 1];
  }

  var main;
  if (c){
    document.body.style.backgroundColor = "white";
    return <div style={{padding:'20px'}}><center><br/><br/>Thank you for your purchase!<br/><br/>Updating Credits....</center></div>
  }else if (n || isLoading){
    document.body.style.backgroundColor = "white";
    return <div style={{padding:'20px'}}><center><br/><br/>Loading...</center></div>
//
  }else if (currentList && systemProgramSetID === programSetID && currentPage){
    main = <MainControl chains={chains} setItemEdited={setItemEdited} itemEdited={itemEdited} logInState={logInState} width={width} height={height} currentList={currentList} organicChanges={organicChanges} userNos={userNos} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} error={error} addToExtraScreen={addToExtraScreen} getHistoryWithDefaults={getHistoryWithDefaults} currentPage={currentPage} nosCredits={nosCredits} setNosCredits={setNosCredits} history={history} setHistory={setHistory} userID={userID} signKey={signKey} sessionID={sessionID} programSetID={programSetID} clickBack={clickBack} setSelectedStep={setSelectedStep} tabSelected={tabSelected} setTabSelected={setTabSelected} changeTab={changeTab} setIsShowingSomeDropDown={setIsShowingSomeDropDown} isShowingSomeDropDown={isShowingSomeDropDown}  clickUndoRedo={clickUndoRedo} isConnected={isConnected} canUndo={canUndo} canRedo={canRedo} saveState={saveState} doingWhat={doingWhat} setDoingWhat={setDoingWhat} isClickingOnContentDiv={isClickingOnContentDiv} setIsClickingOnContentDiv={setIsClickingOnContentDiv} refObject={refObject} setRefObject={setRefObject} whichFEOrPU={whichFEOrPU} setWhichFEOrPU={setWhichFEOrPU} setHidePanelRelativeItems={setHidePanelRelativeItems} hidePanelRelativeItems={hidePanelRelativeItems} simplDuplicate={simplDuplicate} accessLevel={accessLevel} navBarHeight={navBarHeight} setNavBarHeight={setNavBarHeight} zoom={zoom} setZoom={setZoomX} resetZoom={resetZoom} translateX={translateX} setTranslateX={setTranslateX} translateY={translateY} setTranslateY={setTranslateY} tabWidth={tabWidth} centerZoom={centerZoom} screenSize={screenSize} setScreenSize={setScreenSizeX} detailsWidth={detailsWidth} setDetailsWidth={setDetailsWidth} scrollableElement={scrollableElement} isGone={isGone} homeButton={revertProgramIDFnX} tempAddr={tempAddr} setTempAddr={setTempAddr} heightsOfPages={heightsOfPages} setHeightsOfPages={setHeightsOfPages} palette={palette} itemCategories={itemCategories}/>


  }else{
    function setIsShowingPrevious(x){
      window.history.pushState({extraPath:extraScreenSet, currentPageSet, programSetID, isShowingPrevious:x}, '', '');
      setFakePath(window.history.state.extraPath);
    }
      main = <IntroPage chains={chains} userID={userID} sessionID={sessionID} signKey={signKey} tryConnect={tryConnect} width={width} height={height} history={history} sortBy={sortBy} setSortBy={setSortBy} addToExtraScreen={addToExtraScreen} logInState={logInState} logOut={logOut} nosCredits={nosCredits} isShowingPrevious={isShowingPrevious} setIsShowingPrevious={setIsShowingPrevious} selectNew={selectNew} doingWhat={doingWhat} setDoingWhat={setDoingWhat} justLoadHistory={justLoadHistory} clickBack={clickBack} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} palette={palette} changeTab={changeTab}/>      
  }
            
  return <div style={style}>
        {popUps}
        {main}
      </div>



}

export default App;